<template>
    <client-page class="wrap wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'마이페이지'"></sub-visual>
        <mypage-navigation></mypage-navigation>

        <section class="section">
            <v-container>
                <tit-primary
                sc="Attendance status"
                tit="출석 현황">
                </tit-primary>
                
                <v-data-table v-bind="{ items, headers }" hide-default-footer disable-filtering disable-sort class="v-data-table--default table--primary--large">
                    <template #[`item.program.name`]="{ item, value }">
                        <router-link :to="`/service/programs/${item._program}`">{{ value }}</router-link>
                    </template>
                    <template #[`item.program.status`]="{ item, value }">

                        <v-chip v-if="item.program.status == '접수종료'" color="grey-light" label><span class="grey-dark--text">접수종료</span></v-chip>
                        <v-chip v-else-if="item.program.status == '모집마감'" color="primary-dark" label><span class="white--text">모집마감</span></v-chip>
                        <v-chip v-else-if="item.program.status == '진행종료'" color="grey-light" label><span class="grey-dark--text">진행종료</span></v-chip>
                        <v-chip v-else-if="item.program.status == '접수중'" color="primary-light" label><span class="primary--text">접수중</span></v-chip>
                        <v-chip v-else-if="item.program.status == '진행중' && item.isApproved" color="green-light" label><span class="green--text">진행중</span></v-chip>
                        <v-chip v-else :color="stateColor(item)" label><span>{{ value }}</span></v-chip>

                        <!-- <span v-if="item.program.status == '접수종료'" class="grey-8f--text">접수종료</span>
                        <span v-else-if="item.program.status == '모집마감'" class="grey-8f--text">모집마감</span>
                        <span v-else-if="item.program.status == '진행종료'" class="grey-8f--text">진행종료</span>
                        <span v-else-if="item.program.status == '접수중'" class="primary--text">접수중</span>
                        <span v-else-if="item.program.status == '진행중' && item.isApproved" class="green--text text--lighten-1">진행중</span>
                        <span v-else :class="stateColor(item) + '--text'">{{ value }}</span> -->

                    </template>
                    <template #[`item.state`]="{ item, value }">

                        <v-chip v-if="item.program.status == '진행종료'" color="grey-light" label><span class="grey-dark--text">진행종료</span></v-chip>
                        <v-chip v-else-if="item.program.status == '진행중' && item.isApproved" color="primary-light" label><span class="primary--text">진행중</span></v-chip>
                        <v-chip v-else :color="stateColor(item)" label><span>{{ PROGRAM_APPLICATION_STATES[value]?.text }}</span></v-chip>

                        <!-- <v-chip v-if="item.program.status == '진행종료'" label color="grey" class="w-80px w-md-100px w-lg-120px d-flex justify-center">종료</v-chip>
                        <v-chip v-else-if="item.program.status == '진행중' && item.isApproved" label color="green" class="w-80px w-md-100px w-lg-120px d-flex justify-center">진행중</v-chip>
                        <v-chip v-else label dark :color="stateColor(item)" class="w-80px w-md-100px w-lg-120px d-flex justify-center">{{ PROGRAM_APPLICATION_STATES[value]?.text }}</v-chip> -->
                    </template>
                    <template #[`item.cancel`]="{ item }">
                        <v-btn :disabled="!isCancelable(item)" @click="cancel(item)" outlined small rounded elevation="0" color="grey" class="v-btn--table"><span class="grey-dark--text">신청취소</span></v-btn>
                        <!-- <v-btn x-small :disabled="!isCancelable(item)" small elevation="0" color="pink lighten-1" @click="cancel(item)">신청취소</v-btn> -->
                    </template>
                    <template #[`item.attend`]="{ item }">
                        <v-btn v-if="isAttendable(item)" :to="`/mypage/programs/${item._program}`" small rounded elevation="0" color="orange" class="v-btn--table"><span class="white--text">출석확인</span></v-btn>
                        <!-- <v-btn x-small v-if="isAttendable(item)" dark small elevation="0" color="green lighten-1" :to="`/mypage/programs/${item._program}`">출석확인</v-btn> -->
                    </template>
                    <template #footer> <pagination-component :value="page" :count="pageCount" @input="(page) => $router.push({ query: { page } })" /> </template>
                </v-data-table>
            </v-container>
        </section>
 
    </client-page>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";
import { PROGRAM_APPLICATION_STATES } from "@/assets/variables";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";
import PaginationComponent from "@/components/client/control/pagination-component.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";

let headers = [
    { text: "번호", value: "index", width: "5%", align: "center" },
    { text: "프로그램명", value: "program.name", width: "auto", align: "center" },
    { text: "상태", value: "program.status", width: "10%", align: "center" },
    { text: "신청", value: "state", width: "10%", align: "center" },
    { text: "취소", value: "cancel", width: "10%", align: "center" },
    { text: "출석", value: "attend", width: "10%", align: "center" },
];

export default {
    components: {
        ClientPage,
        SubVisual,
        MypageNavigation,
        PaginationComponent,
		TitPrimary,
    },
    data: () => ({
        limit: 10,

        summary: { totalCount: 0 },
        applications: [],

        headers,
        PROGRAM_APPLICATION_STATES,
    }),
    computed: {
        items() {
            return this.applications.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
    },
    mounted() {
        this.reroute().then(this.search);
    },
    watch: {
        page() {
            this.search();
        },
    },
    methods: {
        async reroute() {
            if (!this.$store.state.accessToken) this.$router.push("/login");
        },
        async search() {
            let { skip, limit } = this;
            let { summary, applications } = await api.v1.me.programs.applications.gets({ _program: undefined, headers: { skip, limit } });

            this.summary = summary;
            this.applications = applications;
        },
        async cancel({ _program, _id, program }) {
            let go = confirm(`아래 프로그램에 대한 신청을 취소하시겠습니까?\n\n프로그램명: ${program?.name}`);
            if (go) {
                let { application } = await api.v1.me.programs.applications.putCancel({ _program, _id });
                this.update(application);
            }
        },
        update(item) {
            let index = this.applications.findIndex(({ _id }) => _id == item._id);
            if (index > -1) {
                this.applications.splice(index, 1, item);
            } else {
                this.applications.splice(0, 0, item);
            }
        },
        stateColor({ state }) {
            switch (state) {
                case PROGRAM_APPLICATION_STATES.APPLIED.value:
                    return "accent";
                case PROGRAM_APPLICATION_STATES.CANCELED.value:
                    return "secondary";
                case PROGRAM_APPLICATION_STATES.APPROVED.value:
                    return "primary";
                case PROGRAM_APPLICATION_STATES.REJECTED.value:
                    return "pink lighten-1";
            }
        },
        isCancelable(item) {
            if (item.state == PROGRAM_APPLICATION_STATES.CANCELED.value) return false;
            if (item.state == PROGRAM_APPLICATION_STATES.REJECTED.value) return false;
            if (dayjs().isAfter(item.program.applicationEndsAt, "date")) return false;
            return true;
        },
        isAttendable(item) {
            return item.state == PROGRAM_APPLICATION_STATES.APPROVED.value;
        },
    },
};
</script>
